const Pages = {
  handleAtendimento: function () {
    // HANDLE LOCATION HASH
    if (window.location.hash) {
      $data = window.location.hash.replace('#', '');

      $title = $(`.section-atendimento [data-atendimento-title="${$data}"]`);
      // console.log("....",$title.offset().top)
      var $body = $('body');
      if ($body.width() <= 767) {
        $('html').animate({
          scrollTop: $title.offset().top - 140
        }, '500');
      } else {
        $('html').animate({
          scrollTop: $title.offset().top - 100
        }, '500');
      }
    }
  },
  handleFAQ: function () {
    // HANDLE LOCATION HASH
    if (window.location.hash) {
      $data = window.location.hash.replace('#', '');

      $title = $(`.section-faq [data-faq-subtitle="${$data}"]`);
      var $body = $('body');
      if ($body.width() <= 767) {
        $('html').animate({
          scrollTop: $title.offset().top - 140
        }, '500');
      } else {
        $('html').animate({
          scrollTop: $title.offset().top - 160
        }, '500');
      }
    }
  },
  handleArtistas: function () {
    $('[data-artistas-anchor]').on('click', function () {
      let $anchor = $(this);
      let $anchor_active = $('[data-artistas-anchor].active');

      let $data = $(this).data('artistas-anchor');

      let $blocks = $(`[data-artistas-block="${$data}"]`);
      let $blocks_active = $('[data-artistas-block]');

      if (!$anchor.hasClass('active')) {
        $anchor_active.removeClass('active');
        $anchor.addClass('active');

        $blocks_active.addClass('hidden');
        $blocks.removeClass('hidden');
      }
    });
  },
  handleProfessores: function () {
    // CPF/CNPJ
    var options = {
      onKeyPress: function (cpf, ev, el, op) {
          var masks = ['000.000.000-000', '00.000.000/0000-00'],
              mask = (cpf.length > 14) ? masks[1] : masks[0];
          el.mask(mask, op);
      }
    }
    
    $('#cpf').mask('000.000.000-000', options);
    $("#phone").mask("(00) 90000-0000");
  },
  setArtistasFilter: function () {
    const listaPrincipalArtistas = $(".wrapper-blocks");
    const containerFilter = $(".list-container");
    const listaArtistas = $(".artista-item");
    var listaArtistasFiltrada = []
    $("#filter-input").on("input", function(){
      let stringLength = $("#filter-input").val().length;
      if(stringLength < 3){
        $(listaArtistasFiltrada).hide();
        $(listaPrincipalArtistas).show();
        $(containerFilter).removeClass("show");
        listaArtistasFiltrada = [];
      }
      if(stringLength == 3){
        for(var i = 0; i < listaArtistas.length; i++){
          let stringArtista = listaArtistas[i].innerHTML.toLowerCase();
          let stringFilter = $("#filter-input").val().toLowerCase();
          let itemArtista = listaArtistas[i];
          if(stringArtista.startsWith(stringFilter)){
            listaArtistasFiltrada.push(itemArtista)
          }
        }
      }
      if(stringLength >= 3){
        $(listaArtistasFiltrada).hide();
        $(listaPrincipalArtistas).hide();
        $(containerFilter).addClass("show")
        for(var i = 0; i < listaArtistasFiltrada.length; i++){
          let stringArtista = listaArtistasFiltrada[i].innerHTML.toLowerCase();
          let stringFilter = $("#filter-input").val().toLowerCase();
          let itemListaFiltrada = listaArtistasFiltrada[i];
          if(stringArtista.startsWith(stringFilter)){
            $(itemListaFiltrada).show();
          }
        }
      }
    })
  },
  setColecoesdropDown: function(){
    $(".button-dropdown").on("click", function(){
      $(".anchors-dropdown .wrap-itens").toggleClass("active");
    })
    $(".wrap-itens .item").on("click", function(e){
      e.preventDefault()
      var idItem = $(this).attr("href");
      var offsetTop = $(idItem).offset().top;
      $(".anchors-dropdown .wrap-itens").toggleClass("active");
      window.scroll({
        top: offsetTop - 0
      });
    })
    // $(window).on("load",function () {
    //   var offsetTop = $(location.hash).offset().top;
    //   if(location.hash != null && location.hash != "") {
    //     window.scroll({
    //       top: offsetTop - 120,
    //     });
    //   }
    // })
  },
  init: function () {
    const _this = this;  
    if (window.location.href.includes('termos-de-uso')) _this.handleAtendimento();
    if (window.location.href.includes('artistas-e-autores')) _this.handleArtistas();
    if (window.location.href.includes('artistas-e-autores')) _this.setArtistasFilter();
    if (window.location.href.includes('perguntas-frequentes')) _this.handleFAQ();
    if (window.location.href.includes('professores')) _this.handleProfessores();
    if (window.location.href.includes('dramaturgia')) _this.setColecoesdropDown()
  }
}

window.addEventListener('DOMContentLoaded', () => {
  Pages.init();
});
